/* Shōga storefront layer (22/10/2026). The buttons that send the shopper back to the packs ("Try it
   risk-free", the sticky bar's "Choose my pack") scroll there at a pace the eye can follow, then outline
   the packs and focus the pack picked. The theme's own smooth scroll (html scroll-behavior) crosses a
   long page in a blink: it reads as a jump. */
(function () {
  if (window.ShogaScroll) return;
  var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var current = null;

  // A sticky header covers the top of the page again once the shopper scrolls back up.
  function headerSpace() {
    var space = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
      var position = getComputedStyle(el).position;
      if (position === 'sticky' || position === 'fixed') space = Math.max(space, el.offsetHeight);
    });
    return Math.min(space, 160);
  }

  function goal(target) {
    var margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - Math.max(headerSpace() + 12, margin);
    return Math.max(0, top);
  }

  function ease(p) {
    return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
  }

  // Scrolls so that target sits under the header; done runs once there, not when the shopper takes over.
  function to(target, done) {
    var root = document.documentElement;
    var start = window.pageYOffset;
    var distance = Math.abs(goal(target) - start);
    var run = {};
    current = run;
    if (distance < 2 || (motion && motion.matches)) {
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, goal(target));
      root.style.scrollBehavior = '';
      current = null;
      if (done) done();
      return;
    }
    // Slow enough to see the page travel, never longer than 1.3 s.
    var duration = Math.min(1300, Math.max(650, 450 + distance * 0.18));
    var begin = null;
    var stopped = false;
    var stop = function () {
      stopped = true;
    };
    var events = ['wheel', 'touchstart', 'keydown'];
    events.forEach(function (name) {
      window.addEventListener(name, stop, { passive: true });
    });
    var finish = function (arrived) {
      events.forEach(function (name) {
        window.removeEventListener(name, stop);
      });
      if (current === run) {
        current = null;
        root.style.scrollBehavior = '';
      }
      if (arrived && done) done();
    };
    root.style.scrollBehavior = 'auto';
    requestAnimationFrame(function frame(now) {
      if (stopped || current !== run) return finish(false);
      if (begin === null) begin = now;
      var p = Math.min(1, (now - begin) / duration);
      // Read again each frame: an image loading above the packs moves them.
      window.scrollTo(0, start + (goal(target) - start) * ease(p));
      if (p < 1) requestAnimationFrame(frame);
      else finish(true);
    });
  }

  // The packs of an offers block: the batch bar right above them comes into view with them.
  function packs(list, from) {
    var box = list.closest('.offers') || list;
    var section = list.closest('product-blocks');
    var batch = section && section.querySelector('.sg-scar');
    var target = from || (batch && batch.compareDocumentPosition(box) & Node.DOCUMENT_POSITION_FOLLOWING ? batch : box);
    to(target, function () {
      box.classList.remove('sg-flash');
      void box.offsetWidth;
      box.classList.add('sg-flash');
      clearTimeout(box.sgFlash);
      box.sgFlash = setTimeout(function () {
        box.classList.remove('sg-flash');
      }, 1700);
      var input = list.querySelector('[data-offer-input]:checked') || list.querySelector('[data-offer-input]:not(:disabled)');
      if (input) input.focus({ preventScroll: true });
    });
  }

  // In-page links of the Shōga sections (#shg-offer): the packs when the target leads to an offers block.
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[href^="#"]');
    if (!link || !link.closest('.shg, .shg-b')) return;
    var id = decodeURIComponent(link.getAttribute('href').slice(1));
    var target = id && document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    var section = target.closest('product-blocks');
    var list = section && section.querySelector('product-offers');
    if (list) packs(list, target);
    else to(target);
  });

  window.ShogaScroll = { to: to, packs: packs };
})();

/* One buy click = one add to cart (25/10/2026). The offers block sends a pack and its free gifts in a single
   /cart/add.js request, and Shopify publishes one product_added_to_cart per line: the Meta pixel then counted
   3 AddToCart for the 6-bar pack and 2 for the 3-bar pack. The pack still goes through the theme; its gifts
   follow through the Storefront cart API, which publishes no cart event, nested under the pack line as before.
   If that call fails, the gifts go through /cart/add.js: an extra AddToCart, never a pack without its gifts. */
(function () {
  var API = '/api/2026-10/graphql.json';

  function isGift(item) {
    return !!(item && item.properties && item.properties._story_offer_gift !== undefined);
  }

  function variant(id) {
    return 'gid://shopify/ProductVariant/' + id;
  }

  function storefront(query, variables) {
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Storefront API ' + response.status);
        return response.json();
      })
      .then(function (json) {
        if (json.errors || !json.data) throw new Error('Storefront API error');
        return json.data;
      });
  }

  // The gifts, nested under the last line of their pack: the line the theme has just added.
  function addGifts(gifts) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var cartId = 'gid://shopify/Cart/' + cart.token;
        return storefront('query($id: ID!) { cart(id: $id) { lines(first: 100) { nodes { id merchandise { ... on ProductVariant { id } } } } } }', { id: cartId })
          .then(function (data) {
            var nodes = data.cart ? data.cart.lines.nodes : [];
            var lines = gifts.map(function (gift) {
              var line = {
                merchandiseId: variant(gift.id),
                quantity: Number(gift.quantity) || 1,
                attributes: Object.keys(gift.properties || {}).map(function (key) {
                  return { key: key, value: String(gift.properties[key]) };
                })
              };
              var parent = gift.parent_id && nodes.filter(function (node) {
                return node.merchandise && node.merchandise.id === variant(gift.parent_id);
              }).pop();
              if (parent) line.parent = { lineId: parent.id };
              return line;
            });
            return storefront('mutation($cartId: ID!, $lines: [CartLineInput!]!) { cartLinesAdd(cartId: $cartId, lines: $lines) { userErrors { message } } }', { cartId: cartId, lines: lines });
          })
          .then(function (data) {
            if (!data.cartLinesAdd || data.cartLinesAdd.userErrors.length) throw new Error('cartLinesAdd refused');
          });
      });
  }

  // The theme's way, one request: an existing parent line is named by its key, never by its variant id.
  function fallback(gifts) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var items = gifts.map(function (gift) {
          var item = { id: gift.id, quantity: gift.quantity, properties: gift.properties };
          var parent = gift.parent_id && cart.items.filter(function (line) {
            return line.variant_id === Number(gift.parent_id);
          }).pop();
          if (parent) item.parent_line_key = parent.key;
          return item;
        });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      });
  }

  function hook() {
    var cart = window.StoryCart;
    if (!cart || typeof cart.add !== 'function') return false;
    if (cart.shogaGifts) return true;
    var add = cart.add.bind(cart);
    cart.add = function (payload, opts) {
      if (!Array.isArray(payload) || !payload.some(isGift) || payload.every(isGift)) return add(payload, opts);
      var gifts = payload.filter(isGift);
      var rest = payload.filter(function (item) {
        return !isGift(item);
      });
      return add(rest, opts).then(function (result) {
        return addGifts(gifts)
          .catch(function () {
            return fallback(gifts);
          })
          .then(function () {
            // The theme checks the pack's discount on result.cart before it sends the shopper to checkout.
            return cart.fetchCart();
          })
          .then(function (full) {
            if (typeof cart.refresh === 'function') cart.refresh({ silent: true });
            return Object.assign({}, result, { cart: full });
          });
      });
    };
    cart.shogaGifts = true;
    return true;
  }

  if (!hook()) document.addEventListener('DOMContentLoaded', hook);
})();
